import * as React from 'react';

import { alpha } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import SideMenu from './components/SideMenu'; // Sidebar Navigation
import AppNavbar from './components/AppNavbar'; // Mobile Navigation
import AppTheme from '../shared-theme/AppTheme'; // Theming
import { useAuth } from '../components/AuthContext';
import EmailVerificationBanner from '../components/EmailVerificationBanner';

import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from './theme/customizations';

// Combine all theme customizations
const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};

export default function Dashboard({ children }) {
  const { user, emailVerified } = useAuth();
  return (
    <AppTheme themeComponents={xThemeComponents}>
      <CssBaseline enableColorScheme />
      <AppNavbar />
      {user && !emailVerified && <EmailVerificationBanner />}
      <Box
        sx={{
          display: 'flex',
          minHeight: '100vh',
          mt: {
            xs: 'calc(var(--template-frame-height, 0px) + 64px)',
            md: 'var(--template-frame-height, 0px)',
          },
        }}
      >
        {/* Sidebar Navigation */}
        <SideMenu />

        {/* Main content */}
        <Box
          component="main"
          sx={(theme) => ({
            flexGrow: 1,
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : alpha(theme.palette.background.default, 1),
            display: 'flex',
            flexDirection: 'column',
          })}
        >
          {/* Dynamic Page Content */}
          <Stack
            spacing={2}
            sx={{
              alignItems: 'center',
              mx: 3,
              pb: 5,
              mt: 0,
            }}
          >
            {children} {/* Render dynamic content */}
          </Stack>


        </Box>
      </Box>
    </AppTheme>
  );
}
